import Icon from "@components/Icon";
import { ReactNode } from "react";

type EmptyStateProps = {
  /** Bootstrap Icons name, without `bi-`. */
  icon?: string;
  title: ReactNode;
  children?: ReactNode;
};

/** The body of a list or card with nothing to show. */
const EmptyState = ({ icon = "inbox", title, children }: EmptyStateProps) => (
  <div className="text-center text-body-secondary py-5 px-3">
    <Icon icon={icon} size={36} className="d-block mb-2" />
    <div className="fw-semibold text-body">{title}</div>
    {children ? <div className="small mt-1">{children}</div> : null}
  </div>
);

export default EmptyState;
